import { SubscriptionType } from '@/@types/enums/SubscriptionType';

export const PAID_STATUSES = [SubscriptionType.ACTIVE, SubscriptionType.TRIALING];
